module.exports = __webpack_public_path__ + "files/f352997c2a5cfe95ad2d5b7bc830b737.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-italic-webfont.svg
 ** module id = 1018
 ** module chunks = 0
 **/